import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import styled from 'styled-components'
import parse from 'html-react-parser'
import Img from 'gatsby-image'
import { colors } from '../components/Colors'
import { device } from '../components/Breakpoints'
import { Breadcrumb } from '../components/Breadcrumb'
import imgDoacaodeLeite from '../img/mamadeira.png'
import imgBancodeLeite from '../img/banco-de-leite.jpg'
import imgManuseioBanco from '../img/manuseio.jpg'
import PageHeader from '../components/PageHeader'
import PageEye from '../components/PageEye'
import Layout from '../components/Layout'
import VejaTambem from '../components/VejaTambem'
import CentralAtendimento from '../components/CentralAtendimento'

const Container = styled.section`
  width: 100%;
  margin-bottom: 2em;
  @media ${device.mobileL} {
    .laranjaReverso {
      padding: 0.2em 2em 2em !important;
    }
  }
`

const GroupContent = styled.section`
  padding: 2em 0;
  p {
    font-size: 0.8em;
  }
  @media ${device.mobileL} {
    padding: 2em;
    p,
    h2 {
      text-align: left;
    }
  }
  .inner {
    justify-content: space-between;
    p {
      font-size: 0.8em;
    }
    @media ${device.mobileL} {
      flex-wrap: wrap;
    }
    h2 {
      color: #fa7272;
      margin-top: 0;
    }
    li {
      font-size: 0.8em;
      text-align: left;
    }
    .cuidados {
      display: flex;
      align-items: center;
      margin: 20px 0;
      background-color: #ffffff;
      overflow: hidden;
      box-shadow: 0px 31px 95px -40px rgba(0, 0, 0, 0.75);
      @media ${device.mobileL} {
        flex-wrap: wrap;
        max-height: 100%;
      }
      h3 {
        color: ${colors.lilas};
        position: relative;
        margin: 0;
        font-size: 1em;
        padding: 2em;
        :before {
          position: absolute;
          content: '';
          top: 24px;
          left: 38px;
          border: 1px solid ${colors.lilas};
          width: 5%;
          opacity: 0.5;
          @media ${device.mobileL} {
            left: 22px;
          }
        }
        :after {
          position: absolute;
          content: '';
          bottom: 24px;
          left: 38px;
          border: 1px solid ${colors.lilas};
          width: 5%;
          opacity: 0.5;
          @media ${device.mobileL} {
            left: 22px;
          }
        }
        @media ${device.mobileL} {
          padding: 2em 5px 2em 1em;
        }
      }
      div {
        display: flex;
        align-items: center;
        min-height: 250px;
        height: 100%;
        @media ${device.mobileL} {
          order: 1;
          width: 100%;
        }
      }
      img {
        max-height: 500px;
        @media ${device.mobileL} {
          order: 2;
        }
        @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
          /**
      Target IE11
      */
          width: 100% !important;
        }
      }
      p {
        color: #707070;
        padding: 2em;
        @media ${device.mobileL} {
          padding: 1.5em;
        }
      }
      @media ${device.mobileL} {
        justify-content: center;
      }
    }
  }
  :nth-of-type(3) {
    background: ${colors.verdeGradiente};
    color: #ffffff;
    overflow: hidden;
    h2 {
      color: #fff8d1;
    }
    img {
      margin: -215px 0;
      @media ${device.mobileL} {
        margin: 0;
        width: 100%;
      }
    }
  }

  :nth-of-type(4) {
    background: ${colors.laranjaGradienteReverso};
  }
`

export const BancodeLeiteTemplate = ({
  title,
  content,
  image,
  slug,
  color,
  area = 'Estrutura',
  sessoes,
}) => {
  const crumbs = [
    { id: 1, link: '/', title: 'Home', icon: true },
    { id: 2, link: '#', title: area, icon: true },
    {
      id: 3,
      link: slug,
      title,
    },
  ]
  return (
    <>
      <Container>
        <Breadcrumb crumbs={crumbs} />
        <PageHeader
          title={title}
          content={content}
          image={image}
          color={color}
          overflow="visible"
          height="140px"
          right="30px"
          bottom="-66px"
          titleWidth="322px"
          imgWidth="43%"
        />
        <GroupContent>
          <div className="center">{parse(sessoes[0].texto)}</div>
        </GroupContent>
        <GroupContent>
          <div className="inner center">
            <h2>{parse(sessoes[1].tituloDaSessao)}</h2>
            {parse(sessoes[1].texto)}
            <div className="cuidados">
              <div>{parse(sessoes[2].texto)}</div>
              <img
                src={sessoes[2].imagemDaSessao.sourceUrl}
                alt="Banco de leite"
              />
            </div>
            {parse(sessoes[3].texto)}
            <div className="cuidados">
              <img
                src={sessoes[4].imagemDaSessao.sourceUrl}
                alt="Sala de coleta"
              />
              <section>
                <h3>{parse(sessoes[4].tituloDaSessao)}</h3>
                {parse(sessoes[4].texto)}
              </section>
            </div>
          </div>
        </GroupContent>
        <PageEye
          color="vermelho"
          right="-45px"
          imgWidth="51%"
          bottom="20px"
          titleWidth="506px"
          overflow="visible"
          height="380px"
          title={sessoes[5].tituloDaSessao}
          content={sessoes[5].texto}
          image={sessoes[5].imagemDaSessao.sourceUrl}
        />
        <CentralAtendimento />
      </Container>
    </>
  )
}

BancodeLeiteTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
}

const BancodeLeite = ({ data, location }) => {
  const { siteMetadata: site } = data.site
  const { wpPage: page } = data
  const image = page.opEsDaPGina.imagem ? page.opEsDaPGina.imagem.sourceUrl : ''
  const area = location.state ? location.state.area : page.opEsDaPGina.area
  const { paginasRelacionadas } = page.opEsDaPGina
  const { sessaoCustomizada: sessoes } = page.SessoesCustomizadas
  const description = page.excerpt
    ? page.excerpt.replace(/<\/?[^>]+(>|$)/g, '').replace(/\n/g, '')
    : ''

  return (
    <Layout title={`${page.title} – ${site.title}`} description={description}>
      <BancodeLeiteTemplate
        title={page.title}
        content={page.content}
        image={image}
        slug={page.slug}
        color={page.opEsDaPGina.corDoCabecalho}
        area={area}
        sessoes={sessoes}
      />

      <VejaTambem relatedPages={paginasRelacionadas} />
    </Layout>
  )
}

BancodeLeite.propTypes = {
  data: PropTypes.object.isRequired,
}

export default BancodeLeite

export const BancodeLeiteQuery = graphql`
  query BancodeLeiteById($id: String!) {
    site {
      siteMetadata {
        url
        title
      }
    }
    wpPage(id: { eq: $id }) {
      title
      content
      slug
      excerpt
      SessoesCustomizadas {
        sessaoCustomizada {
          listaDeItens {
            item
          }
          texto
          tituloDaSessao
          imagemDaSessao {
            sourceUrl
            localFile {
              childImageSharp {
                fluid {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        }
      }
      opEsDaPGina {
        corDoCabecalho
        area
        imagem {
          sourceUrl
        }
        paginasRelacionadas {
          ... on WpPage {
            id
            title
            slug
          }
        }
      }
    }
  }
`
